import React from 'react';
import Iframe from 'react-iframe';

const ElementaryDistrictPage = () => (
  <Iframe
    url='https://visualization.audit.samiksha.samagra.io/public/dashboard/b222e7f5-a1c8-4fa4-87ee-288e04172fb4?district=Ambala'
    width='100%'
    height='100%'
    display='initial'
    position='relative'
  />
);

export default ElementaryDistrictPage;
